import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import autobind from 'autobind-decorator';

@connect(
    state => ({
        errors: state.apa.errors,
        isSuperUser: state.apa.isSuperUser,
        isAuthenticated: state.apa.isAuthenticated
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Login extends Component {

    state = {
        username: '',
        password: ''
    }

    @autobind
    onSubmit(event) {
        event.preventDefault();
        const {
            username,
            password
        } = this.state;
        this.props.login(username, password)
    }


    render() {
        if (this.props.isAuthenticated) {
            if(this.props.isSuperUser) {
                return <Redirect to="/customer" />
            } else {
                return <Redirect to="/training/welcome" />
            }
        }
        const { errors } = this.props
        const { non_field_errors } = errors;
        return (
            <form className="form-signin" onSubmit={this.onSubmit}>
                <h1>Login</h1>
                {non_field_errors && non_field_errors.map(
                    (error, index) => <p key={`error_${index}`} className='text-danger'>{error}</p>
                )}
                <div className="form-group">
                    <label htmlFor="email">
                        <FormattedMessage id="app.login.username" defaultMessage="Benutzername" />
                    </label>
                    <input id="username" className="form-control" type="text" onChange={
                        e => this.setState({ username: e.target.value })
                    } required={true} autoFocus={true} />
                </div>
                <div className="form-group">
                    <label htmlFor="password">
                        <FormattedMessage id="app.login.password" defaultMessage="Passwort" />
                    </label>
                    <input id="password" className="form-control" type="password" onChange={
                        e => this.setState({ password: e.target.value })
                    } required={true} />
                </div>
                <button type="submit" className="btn btn-block btn-primary">
                    <FormattedMessage id="app.login.login_btn" defaultMessage="Login" />
                </button>
            </form>
        )
    }
}

Login.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
